import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

// matchheight
import {matchHeight} from '../matchHeight';

function reviewSection() {
    var swiper = new Swiper(".review__swiper", {
        modules: [ Pagination, Navigation, Autoplay ],
        slidesPerView: 1,
        spaceBetween: 15,
        centeredSlides: true,
        loop: true,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".review__next",
            prevEl: ".review__prev",
        },
        pagination: {
            clickable: true,
            el: ".review__pagination",
        },
        breakpoints: {
            768: {
                slidesPerView: 1.6,
                spaceBetween: 15,
            },
            1025: {
                slidesPerView: 2.3,
                spaceBetween: 30,
            },
        },
    });
}

function reviewSectionResponsive() {
    const reviewSlide = document.querySelectorAll('.review__swiper-slide');
    matchHeight(reviewSlide);
}

document.addEventListener('DOMContentLoaded', () => {
    reviewSection();
    reviewSectionResponsive();

    const stickyLabel = document.getElementById("sticky-label");
    if(stickyLabel) {
        const items = document.querySelectorAll(".feature-om__item");
        function onScroll() {
            let found = false;
    
            items.forEach(item => {
                const label = item.querySelector(".feature-om__item-label");
                if (label) {
                    label.classList.remove("is-hidden");
                }
            });
    
            items.forEach((item, index) => {
                const rect = item.getBoundingClientRect();
                const itemLabel = item.querySelector(".feature-om__item-label");
    
                if (rect.top <= 150 && rect.bottom >= 0) {
                    if (itemLabel) {
                        stickyLabel.textContent = itemLabel.textContent;
                        stickyLabel.classList.add("is-visible");
                        itemLabel.classList.add("is-hidden");
                        found = true;
                    }
                }
            });
    
            if (!found) {
                stickyLabel.classList.remove("is-visible");
            }
        }
    
        window.addEventListener("scroll", onScroll);
        onScroll();
    }
})

window.addEventListener('resize', () => {
    reviewSectionResponsive();
})